import React from "react";
import PropTypes from "prop-types";
import { Card, Grid, Box, Tooltip } from "@mui/material";
import { Refresh, DirectionsBike, History } from "@mui/icons-material";

import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import MDButton from "shared/components/MDButton";
import FormBicicletas from "../Form/FormBicicletas";

const HeaderBicicletas = ({
  children,
  onIngreso,
  onSalida,
  refreshFlag,
  onError,
  loading = false,
  onRefresh,
}) => {
  const formatTime = () => {
    const now = new Date();
    return now.toLocaleTimeString("es-ES", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  return (
    <MDBox position="relative" mb={4}>
      <Card
        sx={{
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <MDBox
          p={3}
          sx={{
            background: `linear-gradient(135deg, #0b2c51ff 0%, #092945ff 50%, #173d5cff 100%)`,
            borderBottom: "1px solid rgba(255,255,255,0.2)",
          }}
        >
          <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
            <Grid item xs={12} md={6}>
              <MDBox display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    backgroundColor: "rgba(255,255,255,0.2)",
                    borderRadius: "12px",
                    p: 1.5,
                  }}
                >
                  <DirectionsBike sx={{ color: "#ffffff", fontSize: 32 }} />
                </Box>
                <Box>
                  <MDTypography
                    variant="h4"
                    sx={{ color: "#ffffff", fontWeight: "bold", lineHeight: 1.2 }}
                  >
                    Módulo de Bicicletas
                  </MDTypography>
                  <MDTypography variant="body2" sx={{ color: "rgba(255,255,255,0.9)", mt: 0.5 }}>
                    Gestión de ingresos y salidas de bicicletas
                  </MDTypography>
                </Box>
              </MDBox>
            </Grid>

            <Grid item xs={12} md={6}>
              <MDBox
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
              >
                <Box
                  sx={{
                    backgroundColor: "rgba(255,255,255,0.15)",
                    borderRadius: "20px",
                    px: 2,
                    py: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <History sx={{ color: "rgba(255,255,255,0.9)", fontSize: 18 }} />
                  <MDTypography variant="caption" sx={{ color: "#ffffff", fontWeight: 500 }}>
                    {formatTime()}
                  </MDTypography>
                </Box>

                <Tooltip title="Actualizar ganchos" arrow>
                  <MDButton
                    variant="contained"
                    size="small"
                    onClick={onRefresh}
                    disabled={loading}
                    startIcon={<Refresh />}
                    sx={{
                      borderRadius: "10px",
                      textTransform: "none",
                      fontWeight: 600,
                      px: 2.5,
                      py: 1,
                      backgroundColor: "#ffffff",
                      color: "#1565C0",
                      "&:hover": { backgroundColor: "rgba(255,255,255,0.9)" },
                      "&.Mui-disabled": {
                        backgroundColor: "rgba(255,255,255,0.5)",
                        color: "rgba(0,0,0,0.3)",
                      },
                      "& .MuiButton-startIcon": { color: "#1565C0" },
                    }}
                  >
                    {loading ? "Actualizando..." : "Actualizar"}
                  </MDButton>
                </Tooltip>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>

        <MDBox p={3}>
          <FormBicicletas
            onIngreso={onIngreso}
            onSalida={onSalida}
            refreshFlag={refreshFlag}
            onError={onError}
          />
        </MDBox>

        {children && (
          <MDBox p={3} pt={0}>
            {children}
          </MDBox>
        )}
      </Card>
    </MDBox>
  );
};

HeaderBicicletas.defaultProps = {
  children: null,
  onIngreso: null,
  onSalida: null,
  refreshFlag: false,
  onError: null,
  loading: false,
  onRefresh: null,
};

HeaderBicicletas.propTypes = {
  children: PropTypes.node,
  onIngreso: PropTypes.func,
  onSalida: PropTypes.func,
  refreshFlag: PropTypes.bool,
  onError: PropTypes.func,
  loading: PropTypes.bool,
  onRefresh: PropTypes.func,
};

export default HeaderBicicletas;
